<template>
    <div class="header">
        <!-- <div class="brand">
            好身材Pro管理后台
        </div> -->
        <div class="header-title">
            攀高小程序管理系统
        </div>
        <div class="header-right">
            <div class="accountName">欢迎您： {{ accountName }}</div>
            <a @click="quit" href="/#/login">退出</a>
        </div>
    </div>
</template>

<script>
import { logout } from "@/http/login";
export default {
    data() {
        return {
            accountName: "",
        };
    },
    created() {
        this.accountName = sessionStorage.getItem("showname") || "";
    },
    methods: {
        quit() {
            logout()
                .then((res) => {
                  console.log(res.data.result);
                  sessionStorage.removeItem("token");
                })
                .catch((e) => {
                  console.log(e);
                  sessionStorage.removeItem("token");
                });
            // this.$router.push({name:'login'})
        },
    },
};
</script>

<style lang="scss" scoped>
.header {
    box-sizing: border-box;
    height: 80px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding-left: 300px;
    background: #fff;
    color: #333333;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 4px 2px rgba($color: #000000, $alpha: 0.05);
}
.brand {
    position: absolute;
    top: 0%;
    left: 0%;
    z-index: 1000;
    height: 80px;
    width: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 28px;
    background: #8b6bf4;
    color: #fff;
}
.header-title {
    font-size: 30px;
    padding-left: 40px;
    font-family: initial;
    img {
        vertical-align: bottom;
    }
}
.header-right {
    padding-right: 4%;
    padding-top: 35px;
    height: 75px;
    line-height: 40px;
    min-width: 400px;
    display: flex;
    justify-content: flex-end;
    a {
        display: inline-block;
        width: 100px;
        text-align: center;
        color: #333;
        text-decoration: none;
        &:hover {
            color: red;
            cursor: pointer;
        }
    }
}
.accountName {
    font-size: 16px;
    text-align: left;
    padding-right: 50px;
    cursor: default;
    position: relative;
    width: fit-content;
    white-space: nowrap;
    &::after {
        content: "";
        display: block;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 2px;
        height: 20px;
        background: #aaa;
    }
    .icon-xia {
        font-size: 12px;
        position: absolute;
        right: 20px;
        top: 2px;
    }
    .personOptions {
        position: absolute;
        top: 47px;
        left: -10px;
        right: 0;
        z-index: 1000;
        background: #fff;
        border: 1px solid #f2f2f2;
        text-align: center;
        div {
            &:hover {
                color: #0082fe;
            }
        }
    }
}
@media only screen and (max-width: 1700px) {
    .header {
        padding-left: 16%;
    }
}
</style>
